import React, { FC } from 'react';
import { H1, P } from 'MoshtixShared/component-element';
import { Section } from 'MoshtixShared/component-section';
import Footer from 'Components/component-footer';
import { SimpleLogoHeader } from '../component-simple-logo-header';

export const TicketNotAvailable: FC = () => (
  <div>
    <SimpleLogoHeader />
    <Section maxWidth={630}>
      <H1>404 - Ticket Not Available</H1>
      <P>
        This ticket is no longer available. Please reach out to the ticket owner who sent the ticket if you believe this
        to be an error.
      </P>
    </Section>
    <Footer />
  </div>
);
